define([
	"dojo/_base/array",
	"csi/xml",
	"csi/def/ActionFactory",
	"./_StateAction"
], function(array,xml,ActionFactory,_StateAction) {

	return ActionFactory.declare("ReviewReopen", _StateAction, {
		m_tag: "ReviewReopen",

		_getStateRoles: function(/*Context*/ctx) {
			// summary: currently only used for Size Chart
			return ["Size Chart Evaluation Approver"];
		}
	});
});